import { useFlags } from 'launchdarkly-react-client-sdk';

import { Flags } from '@setvi/shared/enums';

/**
 * Whether the product Resources tab reads revops-api product assets (CFS)
 * instead of Setvi associated resources: the `products-revops-assets` LD
 * flag, one switch for web and iOS, so the tab id in the catalog config stays
 * `associatedResources` on both.
 */
export const useProductAssetsEnabled = (): boolean => {
  const flags = useFlags();
  return !!flags?.[Flags.PRODUCTS_REVOPS_ASSETS];
};
